export function normalizeNumber(value: string) {
    return value.replace(/\D/g, '')
}
